import { useContext, useEffect } from 'react';
import { CheckoutContext, CheckoutContextProps } from '../context/CheckoutContext';
import { useLocalizeMessage } from './useFitnessVillageCopy';

const useTitle = (title?: string) => {
  const { company } = useContext(CheckoutContext) as CheckoutContextProps;
  // Route titles are English; the DFC village in Arabic shows its own.
  const localizedTitle = useLocalizeMessage()(title ?? '');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (company?.name) {
      document.title = localizedTitle ? `${company.name} | ${localizedTitle}` : company.name;
    }
  }, [localizedTitle, company?.name]);
};

export default useTitle;
